import Events from "../../Events";
import System from "../System";
import {
    EMPTY_EXCLUSIVE,
    ENTITY_ANY_USER_CAN_EDIT,
    ENTITY_WITH_MANAGER_OR_OWNER,
    EXCLUDE_FROM_RIGHTS_FILTER,
    KEY_BY_ENTITY_NAME
} from "./const";
import { TableFilterFactory } from "./tableFilter/TableFilerFactory";
import Filter3 from "../../storage/filter3/Filter3";
import { getRolesForListCompany } from "./utils";

//TODO сделать это в самом System (или где это делается)
declare global {
    var system: System
}


export default class BaseRights extends Events {

    static ENTITY_ANY_USER_CAN_EDIT: typeof ENTITY_ANY_USER_CAN_EDIT;
    static ENTITY_WITH_MANAGER_OR_OWNER: typeof ENTITY_WITH_MANAGER_OR_OWNER;
    static EXCLUDE_FROM_RIGHTS_FILTER: typeof EXCLUDE_FROM_RIGHTS_FILTER;
    static EMPTY_EXCLUSIVE: typeof EMPTY_EXCLUSIVE;
    // @see DynamicJournal/EntityListTask
    static KEY_BY_ENTITY_NAME: typeof KEY_BY_ENTITY_NAME;

    constructor(
        private manager,
        private params,
        private tableFilterFactory: TableFilterFactory = new TableFilterFactory()
    ) {
        super();

        this.listenTo(this.manager, "change", this.onChangeManager.bind(this));
    }

    // rule: "view", "edit"
    _checkTreeRight(rule, parentId) {
        let rights = this.manager.rights[rule];

        if ( parentId in rights ) {
            return true;
        }

        for (let key in rights) {
            if ( key.indexOf(parentId + ".") === 0 || key === parentId ) {
                return true;
            }
        }

        return false;
    }

    // rule: "view", "edit"
    getTableFilter(rule, tableName) {

        if (!system.user) {
            throw new Error("User is not defined");
        }
        
        if (system.user.isAdmin()) {
            return new Filter3();
        }

        const rights = this.manager.rights[rule];
        const tableFilter = this.tableFilterFactory.createTableFilter(tableName, rights);

        return tableFilter.getFilter();
    }

    getRolesForListCompany(rule) {
        const rights = this.manager.rights[rule];
        const roles = getRolesForListCompany(rights);

        return roles;
    }

    onChangeManager() {
        this.trigger("change");
    }
}


BaseRights.ENTITY_ANY_USER_CAN_EDIT = ENTITY_ANY_USER_CAN_EDIT;
BaseRights.ENTITY_WITH_MANAGER_OR_OWNER = ENTITY_WITH_MANAGER_OR_OWNER;
BaseRights.EXCLUDE_FROM_RIGHTS_FILTER = EXCLUDE_FROM_RIGHTS_FILTER;
BaseRights.EMPTY_EXCLUSIVE = EMPTY_EXCLUSIVE;
// @see DynamicJournal/EntityListTask
BaseRights.KEY_BY_ENTITY_NAME = KEY_BY_ENTITY_NAME;
